'use strict';

var _ = require('lodash');
var FcrService = function FcrService(momentService, configurationService) {
  var NO_FCR_CONSTANT = 'NO_FCR_CONSTANT';
  function getProcessedFcrConfig() {
    var fcrConfigs = configurationService.getFcrConfig();
    if (fcrConfigs.length === 1) {
      var fcrConfig = fcrConfigs[0];
      _.map(fcrConfig.properties.ranges, function (range) {
        range.fcrDateRangeStartMoment = momentService.of(range.fcrDateRangeStart, momentService.FIELD.DEPARTURE_DATE);
        range.fcrDateRangeEndMoment = momentService.of(range.fcrDateRangeEnd, momentService.FIELD.DEPARTURE_DATE);
        return range;
      });
      return fcrConfig;
    }
    return null;
  }
  function isDateInRange(range, dateMoment) {
    return (range.fcrDateRangeStartMoment.isBefore(dateMoment) || range.fcrDateRangeStartMoment.isSame(dateMoment)) && (range.fcrDateRangeEndMoment.isAfter(dateMoment) || range.fcrDateRangeEndMoment.isSame(dateMoment));
  }
  function getAllFcrTagsForSingleDate(dateMoment) {
    var matchingFcrTags = [];
    var fcrConfig = getProcessedFcrConfig();
    if (fcrConfig !== null) {
      var dateMatchingTags = _.chain(fcrConfig.properties.ranges).filter(function (range) {
        return isDateInRange(range, dateMoment);
      }).map(function (range) {
        return range.tag;
      }).uniq().value();
      if (dateMatchingTags.length > 0) {
        matchingFcrTags = _.concat(matchingFcrTags, dateMatchingTags);
      }
    }
    return matchingFcrTags;
  }
  function getAllFcrTagsForMultipleEntities(data, dateAttr) {
    var fcrTagsArray = [];
    _.each(data, function (item) {
      var date = dateAttr ? item[dateAttr] : item;
      var fcrTags = getAllFcrTagsForSingleDate(date);
      fcrTagsArray = _.concat(fcrTagsArray, fcrTags.length > 0 ? fcrTags : NO_FCR_CONSTANT);
    });
    return _.uniq(fcrTagsArray);
  }
  function getFcrTagForCurrentDate() {
    var today = momentService.now(momentService.FIELD.DEPARTURE_DATE);
    var fcrTags = getAllFcrTagsForSingleDate(today);
    return fcrTags.length === 1 ? fcrTags[0] : '';
  }
  function getFcrTagForMultipleEntities(rows, dateAttr) {
    var fcrTag = '';
    var fcrTagsForAllRows = getAllFcrTagsForMultipleEntities(rows, dateAttr);
    if (fcrTagsForAllRows.length > 1) {
      fcrTag = getFcrTagForCurrentDate();
    } else if (fcrTagsForAllRows.length === 1 && fcrTagsForAllRows[0] !== NO_FCR_CONSTANT) {
      fcrTag = fcrTagsForAllRows[0];
    }
    return fcrTag;
  }
  function getFcrTagByDate(date) {
    var fcrTags = getAllFcrTagsForSingleDate(date);
    return fcrTags.length === 1 ? fcrTags[0] : '';
  }
  function getClassGroupIndicesKey(date, market) {
    var fcrTag = getFcrTagByDate(date);
    return market + (fcrTag.length > 0 ? '-' : '') + fcrTag;
  }
  function getFcrTagForMultipleEntitiesWithMarket(market, rows, dateAttr) {
    var fcrTag = getFcrTagForMultipleEntities(rows, dateAttr);
    return market + (fcrTag.length > 0 ? '-' : '') + fcrTag;
  }
  function getClassesFcrSorted() {
    var fcrTag = getFcrTagForCurrentDate();
    var classesIndexes = configurationService.getAllClassesIndexMapping(fcrTag);
    var classes = configurationService.getClasses();
    return classes.sort(function (a, b) {
      var value1 = classesIndexes[a];
      var value2 = classesIndexes[b];
      return value1 - value2;
    });
  }
  function getFcrTagForCurrentDateWithMarket(market) {
    var fcrTag = getFcrTagForCurrentDate();
    return market + (fcrTag.length > 0 && market.length > 0 ? '-' : '') + fcrTag;
  }
  return {
    getFcrTagForMultipleEntities: getFcrTagForMultipleEntities,
    getFcrTagByDate: getFcrTagByDate,
    getClassGroupIndicesKey: getClassGroupIndicesKey,
    getFcrTagForMultipleEntitiesWithMarket: getFcrTagForMultipleEntitiesWithMarket,
    getClassesFcrSorted: getClassesFcrSorted,
    getFcrTagForCurrentDateWithMarket: getFcrTagForCurrentDateWithMarket
  };
};
FcrService.$inject = ['MomentService', 'ConfigurationService'];
module.exports = FcrService;